// extracted by mini-css-extract-plugin
module.exports = {"dialogBody":"dialogBody__r0LlG","dialogFooter":"dialogFooter__3XhXV","form":"form__yw-yc","tabList":"tabList__2YyaD","tabPanel":"tabPanel__1NH3D"};